module.exports = __webpack_public_path__ + "img/default.231aac28.jpg";